<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

defineProps<{
  themesCount: number;
  ideasCount: number;
  entriesCount: number;
}>();
</script>

<template>
  <div class="row q-col-gutter-md q-mb-lg">
    <div class="col-12 col-sm-4">
      <q-card flat bordered>
        <q-card-section class="text-center">
          <q-icon name="comment" size="32px" color="secondary" class="q-mb-sm" />
          <div class="text-h6">{{ entriesCount }}</div>
          <div class="text-caption text-grey-7">{{ t('consultation.ai.summary.entries_count', entriesCount) }}</div>
        </q-card-section>
      </q-card>
    </div>
    <div v-if="themesCount > 0" class="col-12 col-sm-4">
      <q-card flat bordered>
        <q-card-section class="text-center">
          <q-icon name="label" size="32px" color="primary" class="q-mb-sm" />
          <div class="text-h6">{{ themesCount }}</div>
          <div class="text-caption text-grey-7">{{ t('consultation.ai.summary.themes_count', themesCount) }}</div>
        </q-card-section>
      </q-card>
    </div>
    <div v-if="ideasCount > 0" class="col-12 col-sm-4">
      <q-card flat bordered>
        <q-card-section class="text-center">
          <q-icon name="lightbulb" size="32px" color="accent" class="q-mb-sm" />
          <div class="text-h6">{{ ideasCount }}</div>
          <div class="text-caption text-grey-7">{{ t('consultation.ai.summary.ideas_count', ideasCount) }}</div>
        </q-card-section>
      </q-card>
    </div>
  </div>
</template>
